import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=5fc67dc4&scoped=true"
import script from "./DropdownList.vue?vue&type=script&lang=js"
export * from "./DropdownList.vue?vue&type=script&lang=js"
import style0 from "./DropdownList.vue?vue&type=style&index=0&id=5fc67dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc67dc4",
  null
  
)

export default component.exports